import React, { Component, PropTypes } from 'react';
import { Link } from 'react-router';
import moment from 'moment';
import classnames from 'classnames';
import partial from 'lodash/partial';
import truncate from 'lodash/truncate';
import Thumbnail from 'common/components/thumbnail';
import StarRating from 'common/components/star_rating';

export default class ImageNameTile extends Component {
  renderThumbnail() {
    const { item, entryType } = this.props;
    const revision = item.revisions[0];
    const thumbClasses = classnames('tile entry-thumbnail', {
      stacked: item.revisions.length > 1,
    });

    return (
      <Thumbnail className={thumbClasses} image={entryType === 'name'? null : revision.thumbnails[0]}>
        { entryType === "name" && <div className="revision-name">{ revision.name }</div> }
      </Thumbnail>
    );
  }

  render() {
    const { item, grouped, onClick, selected } = this.props;
    const revision = item.revisions[0];
    const truncatedUsername = truncate(item.author_username, { length: 25 });

    return (
      <div className={classnames("column column-block entry", { selected })}
          onClick={partial(onClick, item)}>
        <div className="entry-tile">
          <div className="tile-left">
            { this.renderThumbnail() }

            <StarRating min={1} readonly={true} initialRate={revision.score || 0}
              extraClasses='lg' />
          </div>

          <div className="tile-right">
            <p className="revision-author">
              <span className="entry-number">
                #{ grouped ? item.entry_number : revision.revision_number }
              </span> by {' '}

              <Link>{ truncatedUsername }</Link>{' '}

              <span className="revision-time">{ moment(revision.created_at).fromNow() }</span>
            </p>
          </div>
          <div className="clearfix" />
        </div>
      </div>
    );
  }
}

ImageNameTile.propTypes = {
  item: PropTypes.object.isRequired,
  entryType: PropTypes.string.isRequired,
  selected: PropTypes.bool.isRequired,
  onClick: PropTypes.func.isRequired,
  grouped: PropTypes.bool,
};



// WEBPACK FOOTER //
// ./focus_groups/components/image_name_tile.jsx